import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: 'Do I need to buy expensive cooling gadgets?',
    a: 'No. Most "tools" are already in your kitchen and bathroom.'
  }, {
    q: "Does this work if I'm already on HRT?",
    a: 'Yes, it complements medical treatment by fixing environmental and behavioral triggers.'
  }, {
    q: 'Is it a long book?',
    a: 'No. It is a direct, actionable protocol designed for an exhausted woman to read and implement immediately.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 px-4 bg-night-800/30" data-id="element-17">
      <div className="max-w-3xl mx-auto" data-id="element-18">
        <FadeIn data-id="element-19">
          <h3 className="font-serif text-3xl md:text-4xl text-white mb-12 text-center" data-id="element-20">
            Frequently Asked Questions
          </h3>
        </FadeIn>

        <div className="space-y-4" data-id="element-21">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-22">
              <div className={`border rounded-xl overflow-hidden transition-colors duration-300 ${openIndex === index ? 'border-amber-500/50 bg-night-800' : 'border-night-700 bg-night-900/50 hover:border-night-600'}`} data-id="element-23">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left" data-id="element-24">
                  <span className="font-medium text-lg text-white" data-id="element-25">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-amber-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-26" />
                </button>

                <AnimatePresence data-id="element-27">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-28">
                      <div className="px-6 pb-5 text-cream/80 leading-relaxed border-t border-night-700/50 pt-4" data-id="element-29">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}